import React from 'react';
import { Badge, Button, Dropdown, Icon, Menu, Popover, Tooltip, Input, Select } from 'antd';
import { PERMISSIONS } from '~/constants/permissions.constants';

import { ModuleHeader, ModuleHeaderWrapper, HeaderLeftContent, HeaderRightContent } from '~/components/ModuleHeader';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';

const ButtonGroup = Button.Group;
const { Search } = Input;

var SCREEN_MAP = {
    active: { label: 'Ativos', color: '#52c41a', icon: 'check-circle' },
    archived: { label: 'Arquivados', color: '#8c8c8c', icon: 'file-done' },
};

export const SocietarioHeader = ({
    user,
    list,
    showDrawer,
    handleExportToExcel,
    openPendingDashTasksDrawer,
    screen,
    setScreen,
    search,
    setSearch,
    donePeriod,
    setDonePeriod,
    donePeriods,
    doneVisibleCount,
    stageFilter,
    setStageFilter,
    stageOptions,
    staleDays,
    setStaleDays,
    stalePeriods,
    defaultDonePeriod,
    filterCount,
    hasFiltersToClear,
    onClearAllFilters
}) => {
    var pendingCount = list && list.pending ? list.pending.length : 0;
    // A coluna "Nao Iniciado" chama-se not_started; `list.open` nunca existiu e a
    // contagem de ativos saia sempre sem ela.
    var notStartedCount = list && list.not_started ? list.not_started.length : 0;
    var inProcessCount = list && list.in_process ? list.in_process.length : 0;
    var doneCount = list && list.done ? list.done.length : 0;
    var activeCount = notStartedCount + inProcessCount + doneCount;
    var archivedCount = list && list.archived ? list.archived.length : 0;

    var periods = donePeriods || [];
    var currentPeriod = null;
    for (var i = 0; i < periods.length; i++) {
        if (periods[i].value === donePeriod) currentPeriod = periods[i];
    }
    // O padrão (90 dias) também esconde concluídos antigos, mas não é um filtro
    // escolhido: não conta no badge e a pílula dele não tem "x".
    var periodDefault = defaultDonePeriod === undefined ? 90 : defaultDonePeriod;
    var isPeriodChanged = donePeriod !== periodDefault;
    var isPeriodLimited = !!currentPeriod && currentPeriod.value !== 0;
    var hiddenDoneCount = doneCount - (doneVisibleCount === undefined ? doneCount : doneVisibleCount);

    // Badge: only what differs from the defaults (computed by the dashboard).
    var badgeCount = filterCount || 0;

    var options = stageOptions || [];
    var currentStage = null;
    for (var j = 0; j < options.length; j++) {
        if (options[j].key === stageFilter) currentStage = options[j];
    }

    // Build pills
    var pills = [];
    var screenInfo = SCREEN_MAP[screen] || SCREEN_MAP.active;
    pills.push({
        key: 'screen',
        label: screenInfo.label,
        color: screenInfo.color,
        icon: screenInfo.icon,
        onRemove: screen !== 'active' ? function() { setScreen('active'); } : undefined,
    });
    if (screen === 'active' && currentPeriod && (isPeriodLimited || isPeriodChanged)) {
        pills.push({
            key: 'donePeriod',
            label: 'Concluídos: ' + currentPeriod.label.toLowerCase(),
            color: '#52c41a',
            icon: 'clock-circle',
            onRemove: isPeriodChanged && setDonePeriod ? function() { setDonePeriod(periodDefault); } : undefined,
        });
    }

    if (screen === 'active' && stageFilter) {
        pills.push({
            key: 'stage',
            label: 'Etapa da vez: ' + (currentStage ? currentStage.short : stageFilter),
            color: '#1890ff',
            icon: 'flag',
            onRemove: function() { setStageFilter(null); },
        });
    }
    if (screen === 'active' && staleDays) {
        pills.push({
            key: 'stale',
            label: 'Parados há ' + staleDays + '+ dias',
            color: '#fa541c',
            icon: 'hourglass',
            onRemove: function() { setStaleDays(0); },
        });
    }
    if (screen === 'active' && search) {
        pills.push({
            key: 'search',
            label: 'Busca: ' + search,
            color: '#722ed1',
            icon: 'search',
            onRemove: function() { setSearch(''); },
        });
    }

    // "Limpar tudo" volta tudo ao padrão (inclusive 90 dias), via resetFilters().
    var handleClearAllFilters = function() {
        if (onClearAllFilters) onClearAllFilters();
    };

    return (
        <>
        <ModuleHeader
                breadcrumbs={['Dep. Societário', 'Painel']}
                title={
                    <span>Departamento Societário <Tooltip title="Abertura, Alteração, Encerramento e Tarefas esporádicas">
                        <small><Icon type="info-circle" /></small>
                    </Tooltip>
                    </span>
                }
                search={
                    <Search
                        placeholder="Pesquisar por cód ou cliente"
                        value={search}
                        onChange={function(e) { setSearch(e.target.value); }}
                        style={{ maxWidth: 300 }}
                    />
                }
                center={
                    <>
                        <Popover
                            trigger="click"
                            placement="bottomRight"
                            content={
                                <div style={{ width: 320 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                                        <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            {hasFiltersToClear && (
                                                <a
                                                    style={{ fontSize: 12, color: '#f5222d' }}
                                                    onClick={handleClearAllFilters}
                                                >
                                                    Limpar tudo
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                                        {/* Screen filter */}
                                        <div>
                                            <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Visualização</div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                                {[
                                                    { value: 'active', label: 'Ativos', color: '#52c41a', icon: 'check-circle', count: activeCount },
                                                    { value: 'archived', label: 'Arquivados', color: '#8c8c8c', icon: 'file-done', count: archivedCount },
                                                ].map(function(opt) {
                                                    var isActive = screen === opt.value;
                                                    return (
                                                        <div
                                                            key={opt.value}
                                                            onClick={function() { setScreen(opt.value); }}
                                                            style={{
                                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                                                                border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                                                                background: isActive ? opt.color + '0a' : '#fafafa',
                                                                transition: 'all 0.2s',
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 13, fontWeight: isActive ? 600 : 400, color: isActive ? '#262626' : '#8c8c8c' }}>
                                                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: opt.color, display: 'inline-block', marginRight: 8 }} />
                                                                {opt.label}
                                                            </span>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                <span style={{ fontSize: 13, fontWeight: 600, color: isActive ? opt.color : '#bfbfbf' }}>{opt.count}</span>
                                                                {isActive && <Icon type="check" style={{ color: opt.color, fontSize: 14 }} />}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        {/* Etapa da vez: onde cada processo está parado agora */}
                                        {screen === 'active' && setStageFilter && (
                                            <div>
                                                <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Etapa da vez</div>
                                                <Select
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    placeholder="Todas as etapas"
                                                    value={stageFilter || undefined}
                                                    onChange={function(value) { setStageFilter(value || null); }}
                                                    getPopupContainer={function(trigger) { return trigger.parentNode; }}
                                                    style={{ width: '100%' }}
                                                >
                                                    {options.map(function(opt) {
                                                        return (
                                                            <Select.Option key={opt.key} value={opt.key}>
                                                                {opt.short + ' — ' + opt.label}
                                                            </Select.Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        )}

                                        {/* Parado há mais de X dias sem nenhuma etapa marcada */}
                                        {screen === 'active' && setStaleDays && (stalePeriods || []).length > 0 && (
                                            <div>
                                                <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Parado há (sem etapa marcada)</div>
                                                <div style={{ display: 'flex', gap: 6 }}>
                                                    {stalePeriods.map(function(opt) {
                                                        var isActive = staleDays === opt.value;
                                                        return (
                                                            <div
                                                                key={opt.value}
                                                                onClick={function() { setStaleDays(opt.value); }}
                                                                style={{
                                                                    flex: 1, textAlign: 'center',
                                                                    padding: '5px 4px', borderRadius: 6, cursor: 'pointer', fontSize: 12,
                                                                    border: '1.5px solid ' + (isActive ? '#fa541c' : '#e8e8e8'),
                                                                    background: isActive ? '#fa541c0a' : '#fafafa',
                                                                    color: isActive ? '#262626' : '#8c8c8c',
                                                                    fontWeight: isActive ? 600 : 400,
                                                                }}
                                                            >
                                                                {opt.label}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                        {/* Periodo da coluna Concluido */}
                                        {screen === 'active' && periods.length > 0 && (
                                            <div>
                                                <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Concluídos</div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                                    {periods.map(function(opt) {
                                                        var isActive = donePeriod === opt.value;
                                                        return (
                                                            <div
                                                                key={opt.value}
                                                                onClick={function() { setDonePeriod(opt.value); }}
                                                                style={{
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                    padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                                                                    border: '1.5px solid ' + (isActive ? '#52c41a' : '#e8e8e8'),
                                                                    background: isActive ? '#52c41a0a' : '#fafafa',
                                                                    transition: 'all 0.2s',
                                                                }}
                                                            >
                                                                <span style={{ fontSize: 13, fontWeight: isActive ? 600 : 400, color: isActive ? '#262626' : '#8c8c8c' }}>
                                                                    {opt.label}
                                                                </span>
                                                                {isActive && <Icon type="check" style={{ color: '#52c41a', fontSize: 14 }} />}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {hiddenDoneCount > 0 && (
                                                    <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 8 }}>
                                                        {hiddenDoneCount + ' concluída' + (hiddenDoneCount > 1 ? 's' : '') + ' fora do período'}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                        >
                            <Badge
                                count={badgeCount}
                                offset={[-4, 0]}
                                style={{ backgroundColor: '#722ed1' }}
                            >
                                <Button
                                    icon="bars"
                                    style={{ borderRadius: 8 }}
                                >
                                    Filtros
                                </Button>
                            </Badge>
                        </Popover>
                        <Dropdown
                            trigger={['click']}
                            overlay={
                                <Menu onClick={function(event) {
                                    if (event.key === 'export') {
                                        handleExportToExcel();
                                        return;
                                    }
                                    showDrawer(parseInt(event.key), {});
                                }}>
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && (
                                        <Menu.Item key="1"><Icon type="plus" /> Abertura de Empresa</Menu.Item>
                                    )}
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && (
                                        <Menu.Item key="5"><Icon type="swap" /> Troca de Contabilidade (entrada)</Menu.Item>
                                    )}
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && (
                                        <Menu.Item key="7"><Icon type="swap" /> Troca de Contabilidade (saída)</Menu.Item>
                                    )}
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && (
                                        <Menu.Item key="2"><Icon type="edit" /> Alteração Contratual</Menu.Item>
                                    )}
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && (
                                        <Menu.Item key="3"><Icon type="close-circle" /> Encerramento de Empresa</Menu.Item>
                                    )}
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && (
                                        <Menu.Item key="4"><Icon type="schedule" /> Tarefa</Menu.Item>
                                    )}
                                    {user.permissions.includes(PERMISSIONS.corporate.create) && <Menu.Divider />}
                                    <Menu.Item key="export"><Icon type="file-excel" /> Exportar para Excel</Menu.Item>
                                </Menu>
                            }
                        >
                            <Button icon="plus" shape="circle" />
                        </Dropdown>
                    </>
                }
                advanced={
                    React.createElement(FilterPillsBar, {
                        pills: pills,
                        onClearAll: hasFiltersToClear ? handleClearAllFilters : undefined,
                    })
                }
        />
        {pendingCount > 0 && screen === 'active' && (
            <div style={{
                background: 'linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%)',
                border: '1px solid #ffe58f',
                borderRadius: 8,
                padding: '18px 20px',
                marginTop: 12,
                marginBottom: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{
                        width: 40, height: 40, borderRadius: '50%',
                        background: '#fa8c16',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(250,140,22,0.3)',
                    }}>
                        <Icon type="rise" style={{ fontSize: 20, color: '#fff' }} />
                    </div>
                    <div>
                        <div style={{ fontWeight: 600, fontSize: 14, color: '#262626', marginBottom: 2 }}>
                            {pendingCount + ' processo' + (pendingCount > 1 ? 's' : '') + ' pendente' + (pendingCount > 1 ? 's' : '') + ' do CRM'}
                        </div>
                        <div style={{ fontSize: 13, color: '#595959' }}>
                            <Icon type="link" style={{ fontSize: 12, marginRight: 4, color: '#fa8c16' }} />
                            Leads positivos convertidos no CRM aguardando registro no painel societário.
                        </div>
                    </div>
                </div>
                <Button
                    size="small"
                    onClick={openPendingDashTasksDrawer}
                    style={{
                        background: '#fa8c16',
                        borderColor: '#fa8c16',
                        color: '#fff', borderRadius: 6, fontWeight: 500,
                    }}
                >
                    Ver pendentes
                </Button>
            </div>
        )}
        </>
    );
}

export default SocietarioHeader;